import type { SVGProps } from 'react';

export function IconMenu(props: SVGProps<SVGSVGElement>) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="23"
            height="18"
            viewBox="0 0 23 18"
            fill="none"
            aria-hidden="true"
            {...props}
        >
            <path
                d="M22.083 16C22.4972 16 22.833 16.3358 22.833 16.75C22.833 17.1642 22.4972 17.5 22.083 17.5H0.75C0.335936 17.4998 4.82696e-08 17.1641 0 16.75C1.00841e-06 16.3359 0.335937 16.0002 0.75 16H22.083ZM11.417 8C11.8311 8.00018 12.167 8.33589 12.167 8.75C12.167 9.16411 11.8311 9.49982 11.417 9.5H0.75C0.335936 9.49982 4.82696e-08 9.16411 0 8.75C4.93359e-07 8.3359 0.335936 8.00018 0.75 8H11.417ZM22.083 0C22.4972 -2.71588e-08 22.833 0.335786 22.833 0.75C22.833 1.16421 22.4972 1.5 22.083 1.5H0.75C0.335936 1.49982 4.82696e-08 1.16411 0 0.75C4.93359e-07 0.335895 0.335936 0.000175806 0.75 0H22.083Z"
                fill="white"
            />
        </svg>
    );
}
